<div class="head cce-row">
  <span>EXPORT SHEET TO EXCEL</span>
  <div class="close">
    <mat-icon class="gray" [mat-dialog-close]="true">cancel</mat-icon>
  </div>
</div>
<div class="content cce-row">
  <button (click)="csvLevel(0)">Level 0</button>
  <button (click)="csvLevel(1)">Level 1</button>
  <button (click)="csvLevel(2)">Level 2</button>
</div>
